import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FeatureToggleService } from '../../services/feature-toggle.service';

import { GroupActions } from './actions';

@Injectable()
export class GroupEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: FeatureToggleService,
    private readonly toastrService: ToastrService,
  ) {}

  loadGroups$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(GroupActions.GetGroups.request),
      switchMap(() =>
        this.service.getGroups().pipe(
          map((items) => GroupActions.GetGroups.success({ items })),
          catchError((err: HttpErrorResponse) => {
            this.toastrService.error(err?.message);
            return of(GroupActions.failure({ errorMessage: err?.message }));
          }),
        ),
      ),
    ),
  );
}
